import React from 'react';
import { useAutoSaveField } from '../../Components/AutosaveForm/AutosaveField';
import { AutosaveRadioGroup } from '../../Components/AutosaveForm/AutosaveRadioGroup';
import { MedicationCourse, MedicationType, prettyPrintMedicationCourse } from '../../Contracts/MedicationModels';
import { MedicationExpiryType } from '../../Shared/Types';
export var MedicationCourseField = function (props) {
    var medicationCourseField = useAutoSaveField({
        field: 'medicationCourse'
    });
    var medicationCourse = medicationCourseField.fieldValue;
    var medicationTypeField = useAutoSaveField({
        field: 'medicationType'
    });
    var medicationType = medicationTypeField.fieldValue;
    var medicationExpiryField = useAutoSaveField({
        field: 'medicationExpiry'
    });
    function medicationCourseChanged(value) {
        if (medicationCourse === MedicationCourse.None &&
            ((medicationType === null || medicationType === void 0 ? void 0 : medicationType.value) === MedicationType.EnrmcScript ||
                (medicationType === null || medicationType === void 0 ? void 0 : medicationType.value) === MedicationType.ComplementaryTherapyOrder) &&
            value === MedicationCourse.ShortCourse) {
            medicationExpiryField.onChange({ value: MedicationExpiryType.Fixed });
        }
    }
    return (React.createElement(AutosaveRadioGroup, { readOnly: props.readOnly, label: 'Medication course', field: 'medicationCourse', required: true, onChange: medicationCourseChanged, errorText: props.medicationCourse === MedicationCourse.None ? 'Please make a selection' : undefined, options: [
            {
                label: prettyPrintMedicationCourse(MedicationCourse.Regular),
                value: MedicationCourse.Regular
            },
            {
                label: prettyPrintMedicationCourse(MedicationCourse.ShortCourse),
                value: MedicationCourse.ShortCourse
            },
            {
                label: prettyPrintMedicationCourse(MedicationCourse.AsRequired),
                value: MedicationCourse.AsRequired
            }
        ] }));
};
